import React, { Component } from "react";
import styled from "styled-components";
import { Row, Col } from "styled-bootstrap-grid";
import { Add } from "styled-icons/material/Add";
import { withTranslation, Trans } from "react-i18next";
import { connect } from "react-redux";
import { userDataTech, fetchLocalData } from "../../../../Actions/UserTechData";
import { logoutUser } from "../../../../Actions";
import { withRouter } from "react-router-dom";
import Footer from "../../../Shared/Footer";
import {
  stringToHours,
  TimeConverstion,
  checkObjectChangeArray,
} from "../../../../Api/Utils/ReuseableFunctions";
import { Form } from "react-bootstrap";
import { saveTechnicianWorkHours } from "../../../../Actions/TechnicianTimesheet";
import TimeInput from "../../../Shared/TimeInput";

class AddCallOut extends Component {
  constructor(props) {
    super(props);
    let callOuts =
      props.techData &&
        props.techData.callOuts &&
        props.techData.callOuts.length > 0
        ? props.techData.callOuts
        : [
          {
            callOutHours: 0,
            calloutBusinessToBusiness: 0,
            calloutHomeToBusiness: 0,
            callOutNr: 1,
          },
        ];

    this.state = {
      callOuts: callOuts,
    };

    this.handleFormChange = this.handleFormChange.bind(this);
  }

  addCallOutTask = () => {
    var joined = this.state.callOuts.concat({
      callOutHours: 0,
      calloutBusinessToBusiness: 0,
      calloutHomeToBusiness: 0,
      callOutNr: this.state.callOuts.length + 1,
    });
    this.setState((state) => ({
      callOuts: joined,
    }));
  };
  componentDidUpdate(prevProps) {
    if (
      this.props.saveMessage !== void 0 &&
      this.props.saveMessage.type === "Timesheet Saved Successfully" &&
      this.props.saveMessage.message.errorCd === "SUCCESS"
    ) {
      let payload = {
        technicianId: this.props.ssoId,
        branchId: this.props.branchId,
        clckInOut: "OUT",
        reasonCd: "43",
        signedInBy: null,
        signedOutBy: this.props.ssoId,
        comments: null,
      };
      this.props.dispatch(logoutUser(payload));
    }
    if (prevProps !== this.props) {
      if (this.props.saveData === null) {
        this.props.history.push("hourslogin");
      }
    }
  }

  componentDidMount() {
    if (Object.keys(this.props.saveData).length === 0) {
      this.props.dispatch(fetchLocalData());
      // this.props.history.push("hourslogin");
    }
  }

  handleChange = (e, index) => {
    const { name, value } = e.target;
    let callOuts = JSON.parse(JSON.stringify(this.state.callOuts));
    if (!isNaN(value) && value >= 0) {
      callOuts[index][name] = Number(value);
      this.setState({ callOuts });
    }
  };

  handleFormChange(index, val, name) {
    let callOuts = this.state.callOuts;
    callOuts[index][name] = stringToHours(val);
    this.setState({ callOuts });
  }

  submitForm = (event, nextFlag) => {
    event.preventDefault();
    var data = this.props.saveData;
    data.isCallOutOrRoadside = "Y";
    data.callOuts = this.state.callOuts.filter(
      (callOut) => callOut.callOutHours !== 0
    );
    this.props.dispatch(userDataTech(data));
    if (
      this.props.security &&
      nextFlag &&
      (this.props.security.timeForTime === "Y" ||
        this.props.security.timeForTime === "B")
    ) {
      this.props.history.push("hoursadjustment&payment");
    } else {
      if (this.props.security.timeForTime === "T") {
        data.paymentType = "T";
        data.callOuts.forEach((items) => items.paymentType === "T");
      }
      if (this.props.security.timeForTime === "N") {
        data.paymentType = "P";
        data.callOuts.forEach((items) => items.paymentType === "P");
      }
      this.props.dispatch(saveTechnicianWorkHours(data));
    }
  };

  backStep = (event) => {
    event.preventDefault();
    this.props.history.push("hourslogin");
  };

  render() {
    const { callOuts } = this.state;
    const { security } = this.props;
    var nextFlag = false;
    if (this.props.techData && this.props.techData.isBeforeSubmitted === "N") {
      nextFlag =
        this.props.security &&
        (this.props.security.timeForTime === "Y" ||
          this.props.security.timeForTime === "B");
    } else {
      nextFlag =
        this.props.security &&
        (this.props.security.timeForTime === "Y" ||
          this.props.security.timeForTime === "B") &&
        checkObjectChangeArray(callOuts, this.props.techData.callOuts);
    }

    return (
      <ParentDiv>
        <TextMessage>
          <Trans>enterDetailsForCallOutRoadsideActivities</Trans>
        </TextMessage>
        <RowHead>
          <ColNames col sm="2">
            {/* <Trans>callOut</Trans> # */}
          </ColNames>
          <ColNames col sm="4">
            <Trans>homeToBusinessKms</Trans>
          </ColNames>
          <ColNames col sm="3">
            <Trans>BusinessToBusinessKms</Trans>
          </ColNames>
          <ColNames col sm="3">
            <Trans>hours</Trans>
          </ColNames>
        </RowHead>
        <AddButton onClick={this.addCallOutTask}>
          <Add size="15" />
          <Trans>addCallout</Trans>
        </AddButton>
        <Form
          onSubmit={(e) => {
            this.submitForm(e, nextFlag);
          }}
        >
          <ScrollDiv>
            {callOuts.map((callOut, index) => (
              <RowValues key={index}>
                <ColNameInput col sm="2">
                  {index + 1}
                </ColNameInput>
                <ColNameInput col sm="4">
                  <Input
                    type="number"
                    onChange={(e) => this.handleChange(e, index)}
                    key={index}
                    min={0}
                    name="calloutHomeToBusiness"
                    value={callOut.calloutHomeToBusiness || 0}
                  />
                </ColNameInput>
                <ColNameInput col sm="3">
                  <Input
                    type="number"
                    onChange={(e) => this.handleChange(e, index)}
                    min={0}
                    name="calloutBusinessToBusiness"
                    value={callOut.calloutBusinessToBusiness || 0}
                  />
                </ColNameInput>
                <ColNameHours col sm="3">
                  <TimeInput
                    breakCal={security.enableBreaksCal === "Y"}
                    target="callOutHours"
                    time={TimeConverstion(callOut.callOutHours)}
                    setTime={(val, name) =>
                      this.handleFormChange(index, val, name)
                    }
                    showMinInt={security.showMintInt === "Y"}
                  />
                </ColNameHours>
              </RowValues>
            ))}
          </ScrollDiv>

          <Footer>
            {" "}
            <BackButton
              onClick={(e) => {
                this.backStep(e);
              }}
            >
              <Trans>back</Trans>
            </BackButton>
            <ButtonSubmit type="submit">
              {nextFlag ? <Trans>next</Trans> : <Trans>submitAndLogout</Trans>}
            </ButtonSubmit>
          </Footer>
        </Form>
      </ParentDiv>
    );
  }
}

const mapStateToProps = ({
  userMessage,
  auth,
  userTechData,
  technicianTimesheet,
  fetchTimesheetSecurity,
  saveTechnicianTimesheet,
}) => {
  return {
    message: userMessage,
    saveData: userTechData.payload,
    techData: technicianTimesheet.payload,
    saveMessage: saveTechnicianTimesheet,
    security: fetchTimesheetSecurity.securityList,
    branchId: auth.user ? auth.user.defaultProfile.branchId : null,
    ssoId: auth.ssoId,
  };
};

export default withRouter(
  connect(mapStateToProps)(withTranslation()(AddCallOut))
);
const TextMessage = styled.div`
  position: relative;
  font-weight: 500;
  color: #4a4a4a;
  text-align: center;
  border-bottom: 1px solid #e0d5d5;
  width: 80%;
  margin: 0 auto;
  padding-bottom: 12px;
  font-size: 24px;
`;
const ParentDiv = styled.div`
  text-align: center;
  font-family: Trebuchet MS;
  position: relative;
`;
const Input = styled.input`
  border-radius: 3px;
  position: relative;
  width: 84px;
  background: ${(props) => (props.color === "silver" ? " #ebeef3" : "white")};
  border: 1px solid #babec3;
  padding: 5px;
  height: 32px;
  text-align: center;
`;
const RowHead = styled(Row)`
  background: #f1f4f9;
  position: relative;
  margin: 19px 252px 0 195px;
  padding: 5px;
`;
const AddButton = styled.button`
  position: absolute;
  height: 35px;
  width: 100px;
  border-radius: 19px;
  border: 1px solid #95989a;
  background: #ffffff;
  color: #b9b4b4;
  text-align: left;
  font-size: 11px;
  right: 10%;
  top: 68px;
`;
const ColNames = styled(Col)`
  text-align: center;
`;
const ColNameInput = styled(Col)`
  text-align: center;
  padding-top: 14px;
`;
const ColNameHours = styled(Col)`
  text-align: center;
`;
const RowValues = styled(Row)`
  margin: 0px 235px 0 176px;
  padding: 5px;
`;
const ScrollDiv = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 350px;
`;
const ButtonSubmit = styled.button`
  background: ${(props) => (props.Color ? "#e1e5eb" : "#c4151c")};
  border-radius: 30px;
  padding: 0;
  border: ${(props) => (props.Color ? "1px solid #96989a;" : "none")};
  height: 34px;
  width: 129px;
  color: ${(props) => (props.Color ? "#939292;" : "#ffffff")};
  font-weight: 50;
  position: relative;
  left: 40px;
  font-size: 12px;
  &:disabled {
    cursor: not-allowed;
    background: #e1e5eb;
    color: #939292;
    border: 1px solid #96989a;
  }
`;
const BackButton = styled.button`
  border: 2px solid #e0e0e0;
  width: 130px;
  height: 35px;
  border-radius: 50px;
  background: #ffffff;
  color: #434f5b;
  font-size: 12px;
`;
